import React from 'react';
import './DropdownComponent.css';

const DropdownComponent = ({
    disabled = false,
    name,
    value,
    placeholder,
    onChange,
    error,
    options = [],
    style = {},
    ...props
}) => {

    const handleValueChange = (e) => {
        onChange && onChange(e);
    };

    return (
        <div className="dropdown-group">
            <select
                disabled={disabled}
                name={name}
                value={value ? value : ""}
                onChange={handleValueChange}
                className={!value ? "placeholder-selected" : ""}
                style={style}
                {...props}>

                <option name={""} value={""} disabled>{placeholder}</option>

                {options.map((option, index) => (
                    <option key={index} name={option.value} value={option.id}>  {/* Using 'id' as the option value */}
                        {option.value}  {/* The label to display in the dropdown */}
                    </option>
                ))}
            </select>
            {error && <span className="error-text">{error}</span>}
        </div>
    );
};

export default DropdownComponent;
